// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ZeroChangeEventBudgetChangesMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventLineItemsInput;
}>;


export type ZeroChangeEventBudgetChangesMutation = { __typename?: 'Mutation', saveChangeEventLineItems: { __typename?: 'SaveChangeEventLineItemsResult', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string } | null | undefined, changeEvent: { __typename?: 'ChangeEvent', id: string, budgetImpactInCents: number, totalCostInCents: number } }> } };


export const ZeroChangeEventBudgetChangesDocument = gql`
    mutation ZeroChangeEventBudgetChanges($input: SaveChangeEventLineItemsInput!) {
  saveChangeEventLineItems(input: $input) {
    changeEventLineItems {
      id
      totalCostInCents
      totalPriceInCents
      proposedBidContractLineItem {
        id
      }
      changeEvent {
        id
        budgetImpactInCents
        totalCostInCents
      }
    }
  }
}
    `;

/**
 * __useZeroChangeEventBudgetChangesMutation__
 *
 * To run a mutation, you first call `useZeroChangeEventBudgetChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZeroChangeEventBudgetChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zeroChangeEventBudgetChangesMutation, { data, loading, error }] = useZeroChangeEventBudgetChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZeroChangeEventBudgetChangesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ZeroChangeEventBudgetChangesMutation, ZeroChangeEventBudgetChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ZeroChangeEventBudgetChangesMutation, ZeroChangeEventBudgetChangesMutationVariables>(ZeroChangeEventBudgetChangesDocument, options);
      }
export type ZeroChangeEventBudgetChangesMutationHookResult = ReturnType<typeof useZeroChangeEventBudgetChangesMutation>;
export type ZeroChangeEventBudgetChangesMutationResult = ApolloReactCommon.MutationResult<ZeroChangeEventBudgetChangesMutation>;